import { render, staticRenderFns } from "./DCTocViewer.vue?vue&type=template&id=0f518ee0"
import script from "./DCTocViewer.vue?vue&type=script&lang=js"
export * from "./DCTocViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports